export default [
  {
    channelName: "ABC Channel",
    img: "img/theme/bootstrap.jpg",
    totalPost: "10",
    admins: "2",
    status: "Public",
    statusType: "kotakblue",
    totalMember: "40"
  },
  {
    channelName: "CDF Channel",
    img: "img/theme/bootstrap.jpg",
    totalPost: "10",
    admins: "2",
    status: "Private",
    statusType: "primary",
    totalMember: "43"
  },
  {
    channelName: "XYZ Channel",
    img: "img/theme/bootstrap.jpg",
    totalPost: "10",
    admins: "2",
    status: "Private",
    statusType: "primary",
    totalMember: "50"
  },
  {
    channelName: "PQR Channel",
    img: "img/theme/bootstrap.jpg",
    totalPost: "10",
    admins: "2",
    status: "Public",
    statusType: "kotakblue",
    totalMember: "30"
  }
];
